export default "__VITE_ASSET__2b08de45__"